import { Injectable } from '@angular/core';
import { SynchronizationCheckpoint } from '../../entities/synchronization-checkpoint';
import { localDb } from '../local-db.service';
import { BaseRepository } from './base.repository';

@Injectable({ providedIn: 'root' })
export class SynchronizationCheckpointRepository extends BaseRepository<
  SynchronizationCheckpoint,
  string
> {
  constructor() {
    super(localDb.synchronizationCheckpoints, 'userEmail');
  }

  async getByUserEmail(userEmail: string): Promise<SynchronizationCheckpoint | undefined> {
    return this.getById(userEmail);
  }

  async save(checkpoint: SynchronizationCheckpoint): Promise<void> {
    await this.upsert(checkpoint);
  }

  async deleteForUser(userEmail: string): Promise<void> {
    await this.delete(userEmail);
  }
}
